// 智能底座接口
import httpRequest from '@/utils/request.js';
// 获取智能底座列表
export const baseList = (params = {}, way) =>
    httpRequest.httpGet({
        url: '/service/plinth/lst/' + way,
        params: {
            ...params
        }
    });
// 底座新增
export const addBase = data => httpRequest.httpPost('/service/plinth/addPlinth', data);

// 获取底座信息
export const getBaseInfo = id =>
    httpRequest.httpGet({
        url: '/service/plinth/getPlinthDetailInfo/' + id
    });

// 编辑底座详情
export const editBaseInfo = data => httpRequest.httpPost('/service/plinth/updatePlinth', data);

// 更改底座基础信息
export const editBaseBaseInfo = data => httpRequest.httpPost('/service/plinth/editPlinth', data);

// 删除底座
export const delBase = data => httpRequest.httpdelete('/service/plinth/del', data);

// 启用 停用底座
export const updateBaseStatus = (ids, type) => httpRequest.httpPost(`/service/plinth/edit/${type}?ids=` + ids);

// 获取可绑定设备列表
export const getBindableDeviceList = params =>
    httpRequest.httpGet({
        url: '/service/plinth/getSensorList',
        params: {
            ...params
        }
    });

// 绑定传感器
export const bindSensor = (baseId, sensorId, way) => httpRequest.httpPost(`/service/plinth/bind/sensor?plinthId=${baseId}&sensorId=${sensorId}&way=${way}`);

// 获取绑定历史分页
export const getHistoryPage = params =>
    httpRequest.httpGet({
        url: '/service/plinth/his/page',
        params
    });

// 获取底座历史数据
export const getHistoryData = params =>
    httpRequest.httpGet({
        url: '/service/share/plinth/history',
        params
    });

// 智能底座导入
export const importBase = (formData, lang) => httpRequest.httpPost(`/service/plinth/importPlinth?language=${lang}`, formData);

// 解除底座传感器绑定
export const unbindSensor = baseId => httpRequest.httpPost(`/service/plinth/unbind?plinthId=${baseId}`);

// 导出底座历史数据
export const exportBaseHistory = params => httpRequest.httpPost('/service/share/export/plinth/history', params);
